import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import C2pa from './pages/C2pa';
import SsaiLive from './pages/SsaiLive';
import SsaiVod from './pages/SsaiVod';
import AiQualityEnhancement from './pages/AiQualityEnhancement';
import LiveAutocaptioning from './pages/LiveAutocaptioning';
import ImmersiveSubtitles from './pages/ImmersiveSubtitles';
import NotFound from './pages/NotFound';
import { getConfig } from './config';
import './App.css';

const App = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let isMounted = true;
    getConfig()
      .then((data) => {
        if (!isMounted) return;
        setConfig(data);
      })
      .catch((error) => {
        console.error('Error loading config:', error);
      });
    return () => { isMounted = false; };
  }, []);

  if (!config) {
    return <div>Loading configuration...</div>;
  }

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/c2pa" element={<C2pa />} />
        <Route path="/ssai-live" element={<SsaiLive config={config} />} />
        <Route path="/ssai-vod" element={<SsaiVod config={config} />} />
        <Route path="/ai-quality-enhancement" element={<AiQualityEnhancement config={config} />} />
        <Route path="/live-autocaptioning" element={<LiveAutocaptioning />} />
        <Route path="/immersive-subtitles" element={<ImmersiveSubtitles />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <footer id="contact" className="bg-white border-t border-gray-200">
        <div className="mx-auto max-w-7xl px-6 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-gray-700">
          <div>© {new Date().getFullYear()} BIG BLUE MARBLE PSO Team</div>
          <div className="flex flex-wrap gap-3 opacity-80">
            <span>Engineering the media world</span>
          </div>
        </div>
      </footer>
    </Router>
  );
};

export default App;


